module.exports = __webpack_public_path__ + "d1c0ffe508c03388a5fe167842696bd5.jpg";